import { string } from 'yup';
import { hasNonWhitespaceEdge, isPrintable } from 'utils/strings/strings';

export const genericStringRules = string().min(1, 'Too Short!').max(240, 'Too Long!');

export const strictStringRule = genericStringRules
  .test('has-non-whitespace-edge', 'Must start and end with non-whitespace character.', (value) => {
    return hasNonWhitespaceEdge(value || '');
  })
  .test('isPrintable', 'Must contain only printable characters.', (value) => {
    return isPrintable(value || '');
  });

export const strictlyRequiredStringRule = strictStringRule.required('Required');
